import React, { Link } from 'react-router-dom'

function Section() {
  return (
    <section id='quem-somos' className='flex w-full flex-col items-center justify-center gap-4 pb-20 pt-28 md:gap-8'>
      <div className='grid w-11/12 grid-cols-1 gap-8 md:w-10/12'>
        <div className='flex items-center gap-2 text-xl'>
          <Link to={'/'} className='transition-all duration-500 hover:text-blue'>
            Home
          </Link>
          <span>/</span>
          <Link to={'/contatos'} className='transition-all duration-500 hover:text-blue'>
            Contatos
          </Link>
        </div>

        <div className='grid grid-cols-1 items-center gap-4 md:grid-cols-2 md:gap-8'>
          <div className='animate-scale-in'>
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15327.293381819742!2d-51.68373390391145!3d-24.25187045850007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ec158d3898345d%3A0x646a5943b7e58d2a!2sMacias%20%26%20Cruz%20Advocacia!5e0!3m2!1spt-BR!2sbr!4v1719867007432!5m2!1spt-BR!2sbr'
              loading='lazy'
              referrerpolicy='no-referrer-when-downgrade'
              className='min-h-[390px] w-full md:min-h-[450px]'
            ></iframe>
          </div>

          <div className='flex animate-slide-left flex-col gap-4 text-xl'>
            <header className='flex flex-col gap-2'>
              <h2 className='text-3xl font-semibold uppercase md:text-4xl'>Contatos</h2>
              <p className='text-justify'>
                Entre em contato conosco e descubra como podemos ajudar a proteger seus interesses e garantir seu
                sucesso.
              </p>
            </header>

            <ul className='flex flex-col gap-2'>
              <li>
                <a href='tel:4334727949' target='_blank' className='transition-all duration-300 hover:text-golden'>
                  (43) 3472-7949
                </a>
              </li>
              <li>
                <a
                  href='https://api.whatsapp.com/send?phone=5543998255439&text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consultoria'
                  target='_blank'
                  className='transition-all duration-300 hover:text-golden'
                >
                  (43) 99825-5439
                </a>
              </li>
              <li>
                <a
                  href='mailto:maciasecruz@hotmail.com'
                  target='_blank'
                  className='transition-all duration-300 hover:text-golden'
                >
                  maciasecruz@hotmail.com
                </a>
              </li>
              <li>
                <a
                  href='https://maps.app.goo.gl/c47WTa31QqrhpsZbA'
                  target='_blank'
                  className='transition-all duration-300 hover:text-golden'
                >
                  Praça Yvens Gueguem, 455 - <br /> Ivaiporã, PR, 86870-000
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Section
